import { render, staticRenderFns } from "./UpdateInternationalLogistic.vue?vue&type=template&id=58b93b3c"
import script from "./UpdateInternationalLogistic.vue?vue&type=script&lang=ts"
export * from "./UpdateInternationalLogistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports